import { ChangeDetectionStrategy, Component, computed, input, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DestinationsToggleOptions, QuoteTripDetailsData, TravelersAmountText, TripDetailsIcons } from '@pc/shared';
import { IconComponent } from '@pc/icon';

@Component({
  selector: 'pc-quote-overview-trip-details',
  standalone: true,
  imports: [CommonModule, IconComponent],
  templateUrl: './quote-overview-trip-details.component.html',
  styleUrl: './quote-overview-trip-details.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class QuoteOverviewTripDetailsComponent {
  public quoteTripDetailsData = input.required<QuoteTripDetailsData>();
  public travelersAmountText = input.required<TravelersAmountText>();
  public tripDetailsIcons = input.required<TripDetailsIcons>();
  public selectedDestinationAlt = input.required<string>();
  public destinationsToggleOptions = input.required<DestinationsToggleOptions>();
  public isDestinationsExpanded = signal(false);
  public travelersAmount = computed(() => this.getTravelersAmount());
  public flaggedDestinations = computed(() => this.quoteTripDetailsData().destinations);
  public toggleState = computed(() => this.getDestinationsToggleState());
  public readonly VISIBLE_DESTINATIONS = 3;

  public toggleDestinations(): void {
    this.isDestinationsExpanded.set(!this.isDestinationsExpanded());
  }

  private getTravelersAmount(): string {
    return this.quoteTripDetailsData().travelersAmount === 1
      ? this.travelersAmountText().single
      : `${this.quoteTripDetailsData().travelersAmount} ${this.travelersAmountText().multiple}`;
  }

  private getDestinationsToggleState(): string {
    return this.isDestinationsExpanded()
      ? `${this.destinationsToggleOptions().less}`
      : `+ ${this.quoteTripDetailsData().destinations.length - this.VISIBLE_DESTINATIONS} ${this.destinationsToggleOptions().more}`;
  }
}
